
export interface ContactDetail {
  phones: string[]
  email: string
}
export interface UserResponse {
  contact_detail: ContactDetail
  document_id: string
  name: string
  surname1: string
  surname2: string
  birth_date?: string
  gender?: string
  birth_country?: string
  nationality?: string
  marital_status?: string
  job: Job
  unpaid_installments: string;
  person_id: number;
}

export enum ProcessType {
  REC = 'REC',
  VTA = 'VTA'
}

export enum OriginEnum {
  EMAIL = 'EMAIL',
  SMS = 'SMS',
  WHATSAPP = 'WHATSAPP'
}

export interface ClickToCallRequest {
  document_id: string,
  process_type: ProcessType,
  phone: string,
  origin?: OriginEnum,
  date?: Date | string
}

export interface UTMTrackingData {
  utm_source: string | null,
  utm_medium: string | null,
  utm_campaign: string | null,
  utm_term: string | null,
  utm_content: string | null,
  token: string | null,
  pclient_type: string

}

export interface LedgersRequest {
  document_id: string;
  has_available_amount: boolean;
}

export interface LedgersResponse {
  ledgers: LedgerSearch[];
}

export interface LedgerSearch {
  ledger_id: string;
  initial_amount: number;
  available_amount: number;
  loan_id: string;
  type: string;
  date: string;
}

export interface PostalAddress {
  road_type: string;
  street_name: string,
  number: string;  
  aux?: string;
  postal_code: string;
  city: string;
  province: string;
}

export interface Job {
  contract_type: string;
  monthly_income: string;
  company_name?: string;
  job_type?: string;
  employed_since: string;
}

export interface PeopleResponse {
  person_id: string,
  name: string,
  surname1: string,
  surname2: string,
  document_id: string,
  birth_date: string,
  contact_detail: ContactDetail,
  address: PostalAddress
}